import ERROR_PAGE_METADATA from 'constants/error-pages/error-page-metadata';
import ErrorPage from 'layout/pages/Error/ErrorPage';

const Error403 = () => (
  <ErrorPage
    title="Oops!"
    description="You don't have access to view this page..."
    img="403"
    metadata={ERROR_PAGE_METADATA['403']}
    button={{
      name: 'Go back',
      action: () => {
        window.history.back();
      },
    }}
  />
);

export default Error403;
